import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Icon from './Icon';

const SEASON = 2026;

const ChallengeModal = ({ friend, onClose, onSent }) => {
  const [races, setRaces] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/races?season=${SEASON}`)
      .then(r => setRaces(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSend = async () => {
    if (!selected || sending) return;
    setSending(true);
    setError('');
    try {
      await api.post('/challenges', { userId: friend._id, raceId: selected });
      onSent?.();
      onClose();
    } catch (e) {
      setError(e?.response?.data?.message || 'Erreur lors de l\'envoi.');
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-zinc-900 border border-zinc-700 rounded-2xl w-full max-w-sm shadow-2xl">
        <div className="px-5 py-4 border-b border-zinc-800">
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="text-white font-black text-base flex items-center gap-2"><Icon name="sword" size={14} /> Défier {friend.username}</h3>
              <p className="text-zinc-500 text-xs mt-0.5">Choisis un GP — le joueur avec le plus de points gagne</p>
            </div>
            <button onClick={onClose} className="text-zinc-500 hover:text-white p-1 rounded-lg transition-colors text-lg leading-none shrink-0">✕</button>
          </div>
          <div className="mt-3 flex items-center gap-2 bg-zinc-800/60 border border-zinc-700 rounded-xl px-3 py-2">
            <Icon name="trophy" size={14} />
            <p className="text-zinc-300 text-xs leading-snug">
              Le vainqueur du défi remporte <span className="text-yellow-400 font-black">+1 000 XP</span>.
              En cas d'égalité, personne ne reçoit de bonus.
            </p>
          </div>
        </div>

        <div className="px-5 py-4 max-h-72 overflow-y-auto flex flex-col gap-1.5">
          {loading ? (
            <p className="text-zinc-500 text-sm text-center py-4">Chargement...</p>
          ) : races.length === 0 ? (
            <p className="text-zinc-500 text-sm text-center py-4">Aucune course disponible.</p>
          ) : races.map(race => (
            <button key={race._id} type="button"
              onClick={() => setSelected(race._id)}
              className={`w-full text-left px-3 py-2.5 rounded-xl border transition-all ${
                selected === race._id
                  ? 'border-f1red bg-f1red/10 text-white'
                  : 'border-zinc-800 hover:border-zinc-600 text-zinc-300'
              }`}>
              <span className="text-[10px] text-zinc-500 mr-2">R{race.round}</span>
              <span className="text-sm font-semibold">{race.raceName}</span>
              <span className="text-zinc-600 text-xs ml-2">{race.circuit?.country}</span>
            </button>
          ))}
        </div>

        {error && <p className="text-red-400 text-xs px-5 pb-2">{error}</p>}

        <div className="px-5 py-4 border-t border-zinc-800 flex gap-3">
          <button onClick={onClose} className="flex-1 btn-secondary py-2.5 text-sm">Annuler</button>
          <button onClick={handleSend} disabled={!selected || sending}
            className="flex-1 btn-primary py-2.5 text-sm disabled:opacity-40">
            {sending ? 'Envoi...' : 'Lancer le défi'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChallengeModal;
